import { DefaultTheme } from 'styled-components'

import {
  DefaultBorderRadius,
  DefaultBorderSizes,
  DefaultBreakpoints,
  DefaultColors,
  DefaultShadows,
  DefaultSpacings,
  DefaultTransitionDurations,
  DefaultZIndexLevels,
} from './defaults'
import { MarketShopColors } from './market-shop/colors'
import { MarketShopShadows } from './market-shop/shadows'
import { VisitorParkingColors } from './visitor-parking/colors'

export const theme: DefaultTheme = {
  border: {
    radius: {
      ...DefaultBorderRadius,
    },
    size: {
      ...DefaultBorderSizes,
    },
  },
  breakpoints: {
    ...DefaultBreakpoints,
  },
  colors: {
    ...DefaultColors,
    ...MarketShopColors,
    ...VisitorParkingColors,
  },
  shadow: {
    ...DefaultShadows,
    ...MarketShopShadows,
  },
  space: {
    ...DefaultSpacings,
  },
  transition: {
    duration: {
      ...DefaultTransitionDurations,
    },
  },
  zIndex: {
    ...DefaultZIndexLevels,
  },
}
